import {
  addressList, //地址列表
  saveAddress,//保存地址
  selectOneAddress,//地址详情
  setDefault,//设置默认
  delAddress,//删除地址
  saveCustomerNote,//保存预约信息
  listCustomerNote,//预约信息列表
  deleteCustomerNote,//删除预约信息
  shippingAddressOne,//地址详情
  shippingRemark,//修改备注
  } from "@/api/address.js";
  export default {
    state: {

    },
    actions: {
      // 修改备注
      shippingRemarkAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          shippingRemark(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 帐单列表
      addressListAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          addressList(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // shipping地址详情
      shippingAddressOneAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          shippingAddressOne(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 删除预约信息
      deleteCustomerNoteAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          deleteCustomerNote(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 设为默认
      setDefaultAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          setDefault(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 预约信息列
      listCustomerNoteAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          listCustomerNote(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 保存预约信息
      saveCustomerNoteAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          saveCustomerNote(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 设为默认
      delAddressAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          delAddress(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 保存地址
      saveAddressAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          saveAddress(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 地址详情
        selectOneAddressAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
            selectOneAddress(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },

    },
    mutations: {

    },
    getters: {}
  };
  


// WEBPACK FOOTER //
// ./src/store/module/address.js